<script lang="ts">
	import { onMount } from 'svelte';
	import { format } from 'svelte-i18n';
	import { ParameterCardGroup, ParameterCardGroupV2 } from '@Shelly/shelly-design-system/index';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';
	//Helpers
	import { convertToUnit } from 'src/helpers/units_helpers';
	import {
		CACHE_PV_SELF_CONSUMPTION_TIMEOUT,
		calculateSelfConsumption,
	} from './pv_setup_self_consumption_helper';
	//Types
	import type { PVSetupTypes } from './pv_setup_helper';

	export let pvSetupType: PVSetupTypes;

	let savingsToday: number = null;
	let selfConsumption: number = null;
	let interval: NodeJS.Timeout;

	const getSelfConsumption = async () => {
		if (!pvSetupType) return;
		const selfConsumptionData = await calculateSelfConsumption(pvSetupType);
		selfConsumption = selfConsumptionData.selfConsumption;
		savingsToday = selfConsumptionData.savingsToday;
		clearTimeout(interval);
		interval = setTimeout(getSelfConsumption, CACHE_PV_SELF_CONSUMPTION_TIMEOUT);
	};

	onMount(() => {
		getSelfConsumption();
		return () => {
			clearTimeout(interval);
		};
	});
</script>

{#if $showNewLayout}
	<ParameterCardGroupV2
		sectionParameters={[
			{
				title: savingsToday === null ? '-- %' : convertToUnit(selfConsumption, '%'),
				description: $format('label_self_consumption', {
					default: 'Self-consumption',
				}),
				backgroundColor: '--color-1',
			},
			{
				title:
					savingsToday === null
						? '-- Wh'
						: convertToUnit(savingsToday, 'Wh', { fixed: 2, dontConvert: false }),
				description: $format('label_savings_today', {
					default: 'Savings today',
				}),
				backgroundColor: '--color-1',
			},
		]}
	/>
{:else}
	<ParameterCardGroup
		sectionParameters={[
			{
				title: savingsToday === null ? '-- %' : convertToUnit(selfConsumption, '%'),
				description: $format('label_self_consumption', {
					default: 'Self-consumption',
				}),
			},
			{
				title:
					savingsToday === null
						? '-- Wh'
						: convertToUnit(savingsToday, 'Wh', { fixed: 2, dontConvert: false }),
				description: $format('label_savings_today', {
					default: 'Savings today',
				}),
			},
		]}
	/>
{/if}
